module.exports = __webpack_public_path__ + "img/tire-rugged.945b67bf.svg";